import { DateTime } from "luxon";
import styled from "styled-components";
import { themed, Flow,Loader, Table, Text as Tx, type ColumnDefinition, } from "@bracket/ui";
import { useVaults, } from "@bracket/platform/store";

import { useQuery, } from "@apollo/client";
import { GET_TRANSACTION_LOGS, } from "@gql/queries";
import { useMemo, } from "react";
import { getAccount, } from "wagmi/actions";
import { wagmiConfig, } from "@wagmiconfig";
import { StatusButton, } from "@sections/SettingsPage/tabs/transactions/StatusButton";
import { numberify, } from "@bracket/typescript-utils";

import type { TransactionLogEntry, } from "@gql/types/graphql";




export const Transactions: React.FC = () => {
	themed();

	const { address, } = getAccount(wagmiConfig);
	const { ready, available, } = useVaults();
	const { loading, data, refetch, } = useQuery<{ transaction_log: TransactionLogEntry[]; }>(GET_TRANSACTION_LOGS, { fetchPolicy: "network-only", context: { headers: { wallet: address, }, }, });
	const dataWithIndexes = useMemo(() => {
		return (data?.transaction_log ?? [])
			.map((item, index) => ({
				...item,
				id: index + 1,
			}))
			.sort((a, b) => (a.created > b.created ? -1 : 1));
	}, [data?.transaction_log]);

	const columns: ColumnDefinition<(typeof dataWithIndexes)[number]>[] = [
		{ header: "", accessor: "id", },
		{ header: "Type", accessor: row =>
			<TableCellContainer><Tx sm color="heading">{row.type}</Tx>{ row.sub_type && ( <Tx sm color="subheading">{ row.sub_type }</Tx> ) }</TableCellContainer>
		},
		{ header: "Date", accessor: "created",
			render: value => (
				<TableCellContainer>
					<Tx md color="paragraph">{DateTime.fromISO(value).toFormat("DD")}</Tx>
					<Tx sm color="subheading">{DateTime.fromISO(value).toFormat("h:mm a")}</Tx>
				</TableCellContainer>
			),
		},
		{
			header: "Amount",
			accessor: row => {
				return {
					brkt: row.amount.brkt,
					usd: row.amount.usd,
					label: row.denomination?.label ?? "brktETH",
					decimals: row.denomination?.decimals ?? 18,
				};
			},
			render: ({ brkt, decimals, label, usd, }) => {
				return (
					<TableCellContainer>
						<Tx md color="paragraph">{ numberify(brkt, decimals).toFixed(5) } {label}</Tx>
						<Tx sm color="subheading">{ usd?.toLocaleString("en-US", { style: "currency", currency: "USD", })}</Tx>
					</TableCellContainer>
				);
			},
		},
		{
			header: "Shares",
			accessor: "shares",
			render: (shares: TransactionLogEntry["shares"]) => (
				<Tx md color="paragraph">{shares ? shares : ""}</Tx>
			),
		},
		{
			header: "NAV Price",
			accessor: "nav",
			render: (nav: TransactionLogEntry["nav"]) => (
				<Tx md color="paragraph">
					{nav ? nav.toFixed(2) : ""}
				</Tx>
			),
		},
		{
			header: "Status",
			accessor: ({ trxn_type, status, epoch_available, scheduled_time, symbol, }) => {
				return {
					type: trxn_type,
					status,
					epoch_available,
					scheduled_time,
					symbol,
				};
			},
			render: ( props ) => <Tx md color="paragraph"><StatusButton {...props} /></Tx>,
		},
		]

	if(loading || !ready) {
		return <Loader center scheme="light" />;
	}

	return <Table data={dataWithIndexes} columns={columns} showHeaderSeparator paginate={10} headerColor="subheading" />;

};


const TableCellContainer = styled(Flow)`
	gap: 4px;
`;
